import { k as h, r as L, c as k, d as _, l as x, m as A, n as N, h as i, H as b, g as S, F as E } from "./index-f8317a8e.js";
import { n as I, N as R } from "./index.es-b16d0cf5-386496a9.js";
import { E as C, C as F, N as P } from "./scheduler-store-db06b30a-1e63b67f.js";
import { L as O } from "./constants-67de2eec-b17f5b96.js";
import "react";
import "react-dom";
class j {
  constructor({ schedulerAPIURL: e, nylasSchedulerStore: a, sessionId: n, configId: s }) {
    if (!e)
      throw new Error("schedulerAPIURL is required");
    if (!a)
      throw new Error("nylasSchedulerStore is required");
    if (!n && !s)
      throw new Error("sessionId is required for private configs, if not config id is required for public configs");
    e === "/" && (e = new URL(window.location.href).origin), this.configId = s, this.sessionId = n, this.schedulerAPIURL = e, this.nylasSchedulerStore = a;
  }
  init() {
    _("NylasConnector init");
  }
  get schedulerStore() {
    return this.nylasSchedulerStore;
  }
  get scheduler() {
    return this._schedulerAPIConnector ? this._schedulerAPIConnector : (this._schedulerAPIConnector = new P({
      schedulerAPIURL: this.schedulerAPIURL,
      schedulerStore: this.schedulerStore,
      sessionId: this.sessionId,
      configId: this.configId
    }), this._schedulerAPIConnector);
  }
  resetStores() {
    this.nylasSchedulerStore.reset();
  }
}
const w = (t, e) => {
  const a = t.isLoading, n = t.showNotification, s = t.nylasBranding;
  return i(
    E,
    null,
    n && i("nylas-notification", null),
    a && i(
      "div",
      { class: "loading" },
      i(
        "div",
        { class: "left" },
        i("div", { class: "skeleton" })
      ),
      i(
        "div",
        { class: "right" },
        i("div", { class: "skeleton" }),
        i("div", { class: "skeleton" }),
        i("div", { class: "skeleton" }),
        i("div", { class: "skeleton" }),
        i("div", { class: "skeleton" })
      )
    ),
    !a && e,
    i("div", { class: "footer" }, s && i(
      E,
      null,
      "Powered by ",
      i("nylas-logo", null)
    ))
  );
}, D = (t, e) => i("div", { class: "message-banner" }, e), H = ':host{display:flex;flex-direction:column;overflow:visible;border-radius:var(--nylas-border-radius-2x);width:fit-content;background:var(--nylas-base-0);position:relative;box-shadow:0px 4px 6px -2px rgba(0, 0, 0, 0.05), 0px 10px 15px -3px rgba(0, 0, 0, 0.1);--nylas-primary:#2563eb;--nylas-error:#cc4841;--nylas-error-pressed:#992222;--nylas-wraning:#f06c00;--nylas-success:#16a392;--nylas-info:#2b8fc2;--nylas-base-0:#ffffff;--nylas-base-25:#fcfcfd;--nylas-base-50:#f8f9fc;--nylas-base-100:#eaecf5;--nylas-base-200:#d5d9eb;--nylas-base-300:#b3b8d8;--nylas-base-400:#717bbc;--nylas-base-500:#4e5ba6;--nylas-base-600:#3e4784;--nylas-base-700:#263f72;--nylas-base-800:#293056;--nylas-base-900:#101323;--nylas-base-950:#0e101b;--nylas-border-radius:0.25rem;--nylas-border-radius-2x:0.5rem;--nylas-border-radius-3x:0.75rem;--nylas-font-family:"Inter", sans-serif;font-family:var(--nylas-font-family);font-optical-sizing:auto;font-style:normal;font-variation-settings:"slnt" 0}@media screen and (max-width: 768px){:host{width:auto;min-width:325px}}:root{font-family:inherit}.error{padding:8rem 12rem;color:var(--nylas-base-0);background-color:var(--nylas-error);margin:1.5rem;border-radius:var(--nylas-border-radius-2x)}.message-banner{text-align:right;color:var(--nylas-base-800);padding:1rem;border-bottom:1px solid var(--nylas-color-primary-200);margin-top:1rem}.loading{margin:1.5rem;display:flex;gap:1rem}.loading .skeleton{border-radius:var(--nylas-border-radius-2x);animation:pulsate 1.5s infinite}.loading .skeleton:nth-child(2){animation-delay:-100ms}.loading .skeleton:nth-child(3){animation-delay:-200ms}.loading .skeleton:nth-child(4){animation-delay:-300ms}.loading .skeleton:nth-child(5){animation-delay:-400ms}.loading .left .skeleton{height:100%;width:400px}.loading .right .skeleton{height:5rem;width:300px;margin-bottom:1rem}.loading .right .skeleton:last-child{margin-bottom:0}@keyframes pulsate{0%{background-color:var(--nylas-base-50)}50%{background-color:var(--nylas-base-100)}100%{background-color:var(--nylas-base-50)}}.select-date-page,.additional-data-page,.booked-event-page,.cancelled-event-page,.cancel-flow-page{border-top-left-radius:var(--nylas-border-radius-2x);border-top-right-radius:var(--nylas-border-radius-2x)}.select-date-page,.additional-data-page{display:flex}@media screen and (max-width: 768px){.select-date-page,.additional-data-page{flex-direction:column}}.booked-event-page{background-color:var(--nylas-base-50)}.cancelled-event-page,.cancel-flow-page{padding:1rem;height:496px;display:flex;justify-content:center;align-items:center}.booked-event-page,.cancelled-event-page,.cancel-flow-page{min-width:784px;background:var(--nylas-base-50)}@media screen and (max-width: 768px){.booked-event-page,.cancelled-event-page,.cancel-flow-page{min-width:90%}}.left-panel{display:flex;flex-direction:column;min-width:424px;border-top-left-radius:inherit;background:var(--nylas-base-0);position:relative;padding:1rem 0 0 0;height:624px}@media screen and (max-width: 768px){.left-panel{border-top-right-radius:inherit;min-width:unset;height:auto}}@media screen and (max-width: 768px){.select-date-page .left-panel{padding:0.5rem 4px 0;height:624px}}.border{margin-left:-20px;margin-right:-20px;border-top-width:1px;height:0.5px;background-color:var(--nylas-base-200)}@media screen and (max-width: 768px){.border{display:none}}.right-panel{min-width:360px;width:360px;background-color:var(--nylas-base-50);height:624px;padding-top:16px;border-left:1px solid var(--nylas-base-200);border-top-right-radius:inherit}@media screen and (max-width: 768px){.right-panel{border-top-right-radius:0px;width:inherit;min-width:unset;height:auto}}.right-panel h2{display:flex;margin:0;height:48px;gap:0.5rem;justify-content:center;align-items:center;width:auto;font-size:1.125rem;line-height:1.5rem;font-weight:500;text-align:center;color:var(--nylas-base-800)}.additional-data-page .left-panel{background-color:var(--nylas-base-50)}.additional-data-page .right-panel{background-color:var(--nylas-base-0)}nylas-selected-event-card{height:604px;padding:0 1rem}@media screen and (max-width: 768px){nylas-selected-event-card{height:250px}}.footer{display:flex;justify-content:flex-end;align-items:center;padding:16px;font-size:14px;font-weight:300;color:var(--nylas-base-500);border-top:1px solid var(--nylas-base-200);min-height:24px}.footer svg{fill:var(--nylas-base-500)}.footer svg{margin-top:1px}nylas-selected-event-card::part(nsec__timezone){position:absolute;bottom:0}nylas-notification{margin:1.5rem;width:-webkit-fill-available;width:-moz-available;position:absolute}nylas-locale-switch{position:absolute;padding:18px 20px;bottom:0;width:-webkit-fill-available;width:-moz-available;border-top:1px solid var(--nylas-base-200)}@media screen and (max-width: 768px){nylas-locale-switch{height:auto}}nylas-date-picker{padding:0 20px}', M = H, B = { title: h.t("genericErrorTitle"), type: I.Error, category: C.Component }, U = class {
  constructor(t) {
    L(this, t), this.init = k(this, "init", 7), this.schedulerWillLoad = k(this, "schedulerWillLoad", 7), this.schedulerDidLoad = k(this, "schedulerDidLoad", 7), this.nylasSchedulerError = k(this, "nylasSchedulerError", 7), this.bookingRefExtracted = k(this, "bookingRefExtracted", 7), this.mode = "app", this.defaultSchedulerState = void 0, this.sessionId = void 0, this.schedulerApiUrl = "https://api.us.nylas.com", this.bookingInfo = void 0, this.rescheduleBookingRef = void 0, this.cancelBookingRef = void 0, this.configurationId = void 0, this.nylasBranding = !0, this.eventOverrides = {}, this.isLoading = void 0, this.themeConfig = void 0, this.showNotification = !0, this.automaticComponentRegistration = !0, this.selectedDateLabel = (/* @__PURE__ */ new Date()).toLocaleDateString(void 0, { dateStyle: "full" }) || `${h.t("noDateSelected")}`, this.refConfigId = void 0, this.language = navigator.language;
  }
  connectedCallback() {
    _("[nylas-scheduler] connectedCallback");
  }
  async componentWillLoad() {
    var a, n;
    if (_("[nylas-scheduler] Component will load"), this.schedulerWillLoad.emit(this.host).defaultPrevented)
      return;
    if (this.stores = {
      scheduler: F({
        bookingInfo: this.bookingInfo,
        nylasBranding: this.nylasBranding,
        ...this.defaultSchedulerState
      })
    }, this.baseProvider = new R(this.host, this.stores, this.automaticComponentRegistration, this.eventOverrides), this.refConfigId = this.configurationId, this.rescheduleBookingRef) {
      const [s, o] = x(this.rescheduleBookingRef);
      this.refConfigId = s, this.stores.scheduler.set("rescheduleBookingId", o), this.bookingRefExtracted.emit({ configurationId: s, bookingId: o });
    } else if (this.cancelBookingRef) {
      const [s, o] = x(this.cancelBookingRef);
      this.refConfigId = s, this.stores.scheduler.set("cancelBookingId", o), this.bookingRefExtracted.emit({ configurationId: s, bookingId: o });
    }
    if (!this.checkIfSessionIdOrConfigIdExists())
      return;
    const e = (a = this.baseProvider) == null ? void 0 : a.getStore("scheduler");
    if (this.nylasSchedulerConnector = new j({
      schedulerAPIURL: this.schedulerApiUrl,
      sessionId: this.sessionId,
      configId: this.refConfigId,
      nylasSchedulerStore: e
    }), this.init.emit(this.host), (n = this.baseProvider) == null || n.componentWillLoad(this.nylasSchedulerConnector), this.themeConfig)
      for (const [s, o] of Object.entries(this.themeConfig))
        this.host.style.setProperty(`${s}`, o);
  }
  async componentDidLoad() {
    var d, l, u, f, g, y, p;
    if ((d = this.baseProvider) == null || d.componentDidLoad(), !this.checkIfSessionIdOrConfigIdExists())
      return;
    const t = await ((l = this.nylasSchedulerConnector) == null ? void 0 : l.scheduler.getUISettings());
    (!t || "error" in t) && this.nylasSchedulerError.emit({ notification: { ...this.getErrorObject(t == null ? void 0 : t.error) }, host: this.host });
    const e = (u = this.baseProvider) == null ? void 0 : u.getStore("scheduler"), a = (g = (f = e == null ? void 0 : e.get("configSettings")) == null ? void 0 : f.scheduler) == null ? void 0 : g.available_days_in_future, n = e == null ? void 0 : e.get("selectedTimeslot");
    if (n && (n != null && n.start_time)) {
      if (!this.isTimeslotValid(n))
        return;
      if (e != null && e.get("showBookingForm")) {
        e == null || e.set("selectedDate", n.start_time);
        return;
      }
    }
    const s = e == null ? void 0 : e.get("selectedDate"), o = e == null ? void 0 : e.get("availability");
    let r;
    if (!(o && o.length > 0)) {
      if (s) {
        const { startTime: c, endTime: m, endTimeForAvailableDaysInFuture: v } = this.validateAvailableDaysInFuture(s, a || 30);
        s.getTime() < v * 1e3 && (r = await ((p = this.nylasSchedulerConnector) == null ? void 0 : p.scheduler.getAvailability(c, m)));
      } else {
        const c = /* @__PURE__ */ new Date(), { startTime: m, endTime: v, endTimeForAvailableDaysInFuture: T } = this.validateAvailableDaysInFuture(c, a || 30);
        c.getTime() < T * 1e3 && (r = await ((y = this.nylasSchedulerConnector) == null ? void 0 : y.scheduler.getAvailability(m, v)));
      }
      if ((!r || "error" in r) && this.nylasSchedulerError.emit({ notification: { ...this.getErrorObject(r == null ? void 0 : r.error) }, host: this.host }), !s) {
        let c = /* @__PURE__ */ new Date();
        const m = e == null ? void 0 : e.get("availability").find((v) => new Date(v.start_time) > /* @__PURE__ */ new Date());
        m && (c = m.start_time), e == null || e.set("selectedDate", c);
      }
    }
  }
  componentDisconnected() {
    var t;
    (t = this.baseProvider) == null || t.componentDisconnected();
  }
  bookingInfoChanged(t) {
    var e;
    (e = this.stores) == null || e.scheduler.set("bookingInfo", t);
  }
  rescheduleBookingRefChanged(t) {
    var e, a;
    if (t) {
      const [n, s] = x(t);
      (e = this.stores) == null || e.scheduler.set("rescheduleBookingId", s), this.refConfigId = n, (a = this.nylasSchedulerConnector) == null || a.scheduler.setConfigId(n);
    }
  }
  cancelBookingRefChanged(t) {
    var e, a;
    if (t) {
      const [n, s] = x(t);
      (e = this.stores) == null || e.scheduler.set("cancelBookingId", s), this.refConfigId = n, (a = this.nylasSchedulerConnector) == null || a.scheduler.setConfigId(n);
    }
  }
  languageChanged(t) {
    const e = t.detail;
    this.language = e, h.changeLanguage(e);
  }
  async registerComponentHandler(t) {
    var e;
    (e = this.baseProvider) == null || e.registerComponent(t.detail);
  }
  async unregisterComponentHandler(t) {
    var e;
    (e = this.baseProvider) == null || e.unregisterComponent(t.detail);
  }
  async monthChangedHandler(t) {
    var r, d, l, u, f, g, y;
    const e = t.detail, a = (u = (l = (d = (r = this.nylasSchedulerConnector) == null ? void 0 : r.schedulerStore) == null ? void 0 : d.get("configSettings")) == null ? void 0 : l.scheduler) == null ? void 0 : u.available_days_in_future, { startTime: n, endTime: s, endTimeForAvailableDaysInFuture: o } = this.validateAvailableDaysInFuture(e, a || 30);
    if (n < o && e.getTime() < o * 1e3) {
      const p = await ((f = this.nylasSchedulerConnector) == null ? void 0 : f.scheduler.getAvailability(n, s));
      (!p || "error" in p) && this.nylasSchedulerError.emit({ notification: { ...this.getErrorObject(p == null ? void 0 : p.error) }, host: this.host });
      const c = (g = this.stores) == null ? void 0 : g.scheduler.get("selectableDates");
      c && c.length > 0 && ((y = this.stores) == null || y.scheduler.set("selectedDate", c[0]));
    }
  }
  async bookButtonClickedHandler(t) {
    var s, o, r, d;
    const a = (o = (s = this.nylasSchedulerConnector) == null ? void 0 : s.schedulerStore) == null ? void 0 : o.get("rescheduleBookingId");
    if (a) {
      const l = await ((r = this.nylasSchedulerConnector) == null ? void 0 : r.scheduler.rescheduleBooking(a, t.detail));
      (!l || "error" in l) && this.nylasSchedulerError.emit({ notification: { ...this.getErrorObject(l == null ? void 0 : l.error) }, host: this.host });
      return;
    }
    const n = await ((d = this.nylasSchedulerConnector) == null ? void 0 : d.scheduler.bookTimeslot(t.detail));
    (!n || "error" in n) && this.nylasSchedulerError.emit({ notification: { ...this.getErrorObject(n == null ? void 0 : n.error) }, host: this.host });
  }
  dateSelectedHandler(t) {
    const e = t.detail;
    this.selectedDateLabel = e ? e.toLocaleDateString(void 0, { dateStyle: "full" }) : `${h.t("noDateSelected")}`;
  }
  cancelBookedEventErrorHandler(t) {
    this.nylasSchedulerError.emit({ notification: { ...this.getErrorObject(t.detail.error) }, host: this.host });
  }
  cancelBookedEventValidationErrorHandler(t) {
    this.nylasSchedulerError.emit({ notification: { ...this.getErrorObject(t.detail.error) }, host: this.host });
  }
  rescheduleBookedEventErrorHandler(t) {
    this.nylasSchedulerError.emit({ notification: { ...this.getErrorObject(t.detail.error) }, host: this.host });
  }
  async getNylasSchedulerStore() {
    var t;
    return (t = this.baseProvider) == null ? void 0 : t.getStore("scheduler");
  }
  async getNylasSchedulerConnector() {
    return this.nylasSchedulerConnector;
  }
  async getRef() {
    return this.host;
  }
  getErrorObject(t) {
    return {
      title: (t == null ? void 0 : t.title) || B.title,
      category: (t == null ? void 0 : t.category) || B.category,
      type: I.Error,
      description: (t == null ? void 0 : t.message) || "",
      id: (/* @__PURE__ */ new Date()).getTime().toString(),
      ttl: "none"
    };
  }
  checkIfSessionIdOrConfigIdExists() {
    return !this.sessionId && !this.refConfigId ? (this.nylasSchedulerError.emit({
      notification: {
        title: h.t("noSessionIdErrorTitle"),
        category: C.Component,
        type: I.Error,
        description: h.t("noSessionIdErrorMessage"),
        id: (/* @__PURE__ */ new Date()).getTime().toString(),
        ttl: "none"
      },
      host: this.host
    }), !1) : !0;
  }
  isTimeslotValid(t) {
    return new Date(t.start_time) < /* @__PURE__ */ new Date() ? (this.nylasSchedulerError.emit({
      notification: {
        title: h.t("invalidTimeslotErrorTitle"),
        category: C.Component,
        type: I.Error,
        description: h.t("invalidTimeslotErrorMessage"),
        id: (/* @__PURE__ */ new Date()).getTime().toString(),
        ttl: "none"
      },
      host: this.host
    }), !1) : !0;
  }
  validateAvailableDaysInFuture(t, e) {
    const a = /* @__PURE__ */ new Date(), n = new Date(t.getFullYear(), t.getMonth(), 1).getTime() / 1e3, s = new Date(t.getFullYear(), t.getMonth() + 1, 1).getTime() / 1e3, o = Math.floor(A(a, e).getTime() / 1e3), r = Math.min(o, s);
    return { startTime: n < a.getTime() / 1e3 ? Math.floor(a.getTime() / 1e3) : n, endTime: r, endTimeForAvailableDaysInFuture: o };
  }
  render() {
    var f;
    const t = this.mode === "app", e = (f = this.baseProvider) == null ? void 0 : f.getStore("scheduler"), a = e == null ? void 0 : e.get("eventInfo"), n = e == null ? void 0 : e.get("showBookingForm"), s = e == null ? void 0 : e.get("cancelledEventInfo"), o = e == null ? void 0 : e.get("cancelBookingId"), r = e == null ? void 0 : e.get("selectedTimeslot"), d = e == null ? void 0 : e.get("rescheduleBookingId"), l = (e == null ? void 0 : e.get("nylasBranding")) || this.nylasBranding, u = e == null ? void 0 : e.get("selectedDate");
    if (this.selectedDateLabel = u && this.language ? N(u.toLocaleDateString(O[this.language], { dateStyle: "full" })) : `${h.t("noDateSelected")}`, t && o && !s)
      return i(b, null, i(w, { nylasBranding: l, isLoading: this.isLoading, showNotification: this.showNotification }, i("div", { class: "cancel-flow-page", part: "cancel-flow-page" }, i("nylas-cancel-booking-form", { selectedTimeslot: r, cancelBookingId: o, exportparts: "ncbf, ncbf__input-textfield, ncbf__button-cta, ncbf__button-outline, ncbf__input-label" }))));
    if (t && s)
      return i(b, null, i(w, { nylasBranding: l, isLoading: this.isLoading, showNotification: this.showNotification }, i("div", { class: "cancelled-event-page", part: "cancelled-event-page" }, i("nylas-cancelled-event-card", { cancelledEventInfo: s, exportparts: "ncec, ncec__icon, ncec__title, ncec__description, ncec__button-outline, ncec__card" }))));
    if (t && a)
      return i(b, null, i(w, { nylasBranding: l, isLoading: this.isLoading, showNotification: this.showNotification }, i("div", { class: "booked-event-page", part: "booked-event-page" }, i("nylas-booked-event-card", { selectedTimeslot: r, eventInfo: a, exportparts: "nbec, nbec__title, nbec__card, nbec__description, nbec__button-outline, nbec__cancel-cta, nbec__reschedule-cta" }))));
    if (t && (!a || d) && !n) {
      const g = this.host.querySelector('[slot="timeslot-picker-cta-label"]');
      return i(b, null, i(w, { nylasBranding: l, isLoading: this.isLoading, showNotification: this.showNotification }, d && i(D, null, `${h.t("rescheduleTitle")}`), i("div", { class: "select-date-page", part: "select-date-page" }, i("div", { class: "left-panel" }, i("nylas-date-picker", { exportparts: "ndp, ndp__month-header, ndp__month-button, ndp__day, ndp__date, ndp__date--selected, ndp__date--current-day, ndp__date--current-month" }), i("nylas-locale-switch", null)), i("div", { class: "right-panel" }, i("h2", null, i("calendar-icon", null), i("span", { id: "selectedDate" }, this.selectedDateLabel)), i("nylas-timeslot-picker", { exportparts: "ntp, ntp__timeslot, ntp__timeslot--selected, ntp__button-primary" }, g && i("span", { slot: "timeslot-picker-cta-label" }, i("slot", { name: "timeslot-picker-cta-label" })))))));
    }
    if (t && !a && n) {
      const g = this.host.querySelector('[slot="custom-booking-form"]');
      return i(b, null, i(w, { nylasBranding: l, isLoading: this.isLoading, showNotification: this.showNotification }, d && i(D, null, `${h.t("rescheduleTitle")}`), i("div", { class: "additional-data-page", part: "additional-data-page" }, i("div", { class: "left-panel" }, i("div", { class: "wrapper" }, i("nylas-selected-event-card", { exportparts: "nsec, nsec__card, nsec__icon, nsec__date, nsec__time" }))), i("div", { class: "right-panel" }, i("nylas-booking-form", { exportparts: "nbf, nbf__input-label, nbf__input-textfield, nbf__button-ghost, nbf__button-primary, nbf__button-outline" }, g && i("div", { slot: "custom-booking-form" }, i("slot", { name: "custom-booking-form" })))))));
    }
    return i(b, null, i("slot", null));
  }
  get host() {
    return S(this);
  }
  static get watchers() {
    return {
      bookingInfo: ["bookingInfoChanged"],
      rescheduleBookingRef: ["rescheduleBookingRefChanged"],
      cancelBookingRef: ["cancelBookingRefChanged"]
    };
  }
};
U.style = M;
export {
  U as nylas_scheduling
};
